import {
  login, logout, getUserInfo, register, wxCallbackLogin, pollLogin,
  wxCallbackBind, pollBind, repLogin
} from '@/api/user'
import { view as orgView } from '@/api/org'
import { getToken, setToken, removeToken } from '@/utils/auth'
// import { resetRouter } from '@/router'

const getDefaultState = () => {
  return {
    token: getToken(),
    userInfo: null,
    orgInfo: null
  }
}

const state = getDefaultState()

const mutations = {
  RESET_STATE: (state) => {
    Object.assign(state, getDefaultState())
  },
  SET_TOKEN: (state, token) => {
    state.token = token
  },
  SET_USER_INFO: (state, payload) => {
    state.userInfo = payload
  },
  SET_CURRENT_ORG: (state, payload) => {
    state.orgInfo = payload
    console.log(state.orgInfo)
  }
}

const actions = {
  // user login
  async login({ commit }, userInfo) {
    const { mobile, password } = userInfo
    const response = await login({ account: mobile.trim(), password }, 'login')
    const data = response
    commit('SET_TOKEN', data)
    setToken(data)
    return data
  },

  async repLogin({ commit }, userInfo) {
    const { mobile, password, rep } = userInfo
    const response = await repLogin({ account: mobile.trim(), password: password, rep: rep }, 'login')
    const data = response
    commit('SET_TOKEN', data)
    setToken(data)
    return data
  },

  async wxCallbackLogin({ commit }, data) {
    const res = await wxCallbackLogin(data)

    commit('SET_TOKEN', res)
    setToken(res)
    return res
  },
  async pollLogin({ commit }, uuid) {
    const res = await pollLogin(uuid)
    if (!res) { return null }
    commit('SET_TOKEN', res)
    setToken(res)
    return res
  },

  async wxCallbackBind({ commit }, data, callId) {
    const res = await wxCallbackBind(data, callId, { showError: 'page' })

    commit('SET_TOKEN', res)
    setToken(res)
    return res
  },
  async pollBind({ commit }, uuid) {
    const res = await pollBind(uuid)
    if (!res) { return null }
    commit('SET_TOKEN', res)
    setToken(res)
    return res
  },

  async register({ commit }, data) {
    const res = await register(data, 'register')
    commit('SET_TOKEN', data)
    setToken(res)
    return res.body
  },

  // get user info
  async getUserInfo({ commit, dispatch, state }) {
    if (!getToken()) {
      await dispatch('resetToken')
      return null
    }
    const res = await getUserInfo()
    console.log(res)
    commit('SET_USER_INFO', res)
    return res
  },

  async getOrgInfo({ commit, state }) {
    try {
      const orgId = localStorage.getItem('bd_webapp_orgId')
      const res = await orgView({
        id: orgId
      }, 'getOrgInfo', { showError: 'silent' })
      commit('SET_CURRENT_ORG', res)
      return res
    } catch (e) {
      console.log(e)
      localStorage.removeItem('bd_webapp_orgId')
      localStorage.removeItem('bd_webapp_orgRole')
      commit('SET_CURRENT_ORG', null)
      location.reload()
      // throw e
    }
  },

  async clearOrgInfo({ commit }) {
    commit('SET_CURRENT_ORG', null)
  },

  // user logout
  async logout({ commit, dispatch, state }) {
    await logout()
    await dispatch('resetToken')

    // resetRouter()
  },

  // remove token
  async resetToken({ commit }) {
    removeToken() // must remove  token  first
    localStorage.removeItem('bd_webapp_orgId')
    localStorage.removeItem('bd_webapp_orgRole')

    commit('RESET_STATE')
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}

